module.exports = __webpack_public_path__ + "img/stay_coupon.eba39e96.jpg";